<div class="tickets-content" *ngIf="(identify$ | async)" [ngClass]="partnerIdentify((identify$ | async).token)">
  <div class="tickets-top p-2 pl-4 pr-4">
    <div class="filter-section">
      <div class="filter-from mr-3">
        <mat-form-field appearance="outline">
          <input matInput (click)="picker.open()" readonly [matDatepickerFilter]="myFilter" [matDatepicker]="picker"
            [max]="dateMax" placeholder="{{'TICKETS.DATE FROM' | translate}}" [formControl]="dateFrom"
            (dateChange)="retriveData()" required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="filter-to mr-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <input matInput (click)="picker2.open()" readonly [matDatepickerFilter]="filterFromTo" [matDatepicker]="picker2" [max]="dateMax"
            placeholder="{{'TICKETS.DATE TO' | translate}}" [formControl]="dateTo" (dateChange)="retriveData()"
            required>
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

      </div>
      <div class="filter-type mr-3">
        <mat-form-field class="form-full-width" appearance="outline">
          <mat-select [(value)]="status" (selectionChange)="retriveData()">
            <mat-option [ngClass]="'filter-option'" *ngFor="let status of statuses" [value]="status.value">
              {{('TICKETS.' + status.viewValue | uppercase) | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="example-container">
    <div class="div-loading-shade" *ngIf="isLoadingResults">
      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
    </div>

    <div class="p-2 text-center d-flex justify-content-center align-items-center" style="min-height: 25vh;" *ngIf="serviceError && serviceError.ret_code !== '1024'">
      <h5>
        <span *ngIf="serviceError.ret_code < 2000">{{serviceError.description}}</span>
        <span *ngIf="serviceError.ret_code > 2000">{{serviceError.description | translate}}</span>
        <small>({{serviceError.ret_code}})</small>
      </h5>
    </div>

    <div class="p-2 text-center d-flex justify-content-center align-items-center" style="min-height: 25vh;" *ngIf="(serviceError && serviceError.ret_code === '1024') && isRateLimitReached && !environment.eurobetCID.includes((identify$ | async).token)">
      <h5>{{'TICKETS.NODATA' | translate}}</h5>
    </div>

    <div class="tickets-message-eurobet d-flex p-2 text-center justify-content-center align-items-center" style="min-height: 25vh;" *ngIf="(serviceError && serviceError.ret_code === '1024') && isRateLimitReached && environment.eurobetCID.includes((identify$ | async).token)">
      <div>
        <h5><mat-icon>info_outline</mat-icon> SCHEDINA VUOTA</h5>
        <div class="mb-2">
          <p>Non hai ancora aggiunto scommesse alla tua schedina, cosa aspetti?</p>
        </div>
      </div>
    </div>
    <div class="example-table-container" *ngIf="!isRateLimitReached">
      <table aria-hidden="true" mat-table [dataSource]="dataSource" matSort matSortDisableClear class="text-center">

        <!-- ID Column -->
        <ng-container matColumnDef="data_ora_vendita">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.DATE' | translate}} </th>
          <td class="text-capitalize" mat-cell *matCellDef="let row">
            {{(row.data_ora_vendita | date : 'd MMM yyyy H:mm:ss':'':translateService.currentLang)}}
          </td>
        </ng-container>

        <!-- ID Column -->
        <ng-container matColumnDef="id_biglietto">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.ID' | translate}} </th>
          <td mat-cell *matCellDef="let row">

            <span *ngIf="(row.tipo === 'PSIP' && row.gioco === '3') || row.tipo === 'PSR'" matBadge="T"
              matTooltip="{{'GENERAL.TOTE' | translate}}" matBadgeOverlap="false" class="tot-circle text-danger"
              [ngClass]="{
        'text-danger': row.stato_spoglio === '0' || row.stato_spoglio === '110',
        'text-success': row.stato_spoglio === '1' || row.stato_spoglio === '11',
        'text-info': row.stato_spoglio === '2',
        'text-warning': row.stato_spoglio === '3' || row.stato_spoglio === '13'}">{{row.id_biglietto}}
            </span>

            <span *ngIf="(row.tipo === 'PSIP' && row.gioco === '4')" [ngClass]="{
        'text-danger': row.stato_spoglio === '0' || row.stato_spoglio === '110',
        'text-success': row.stato_spoglio === '1' || row.stato_spoglio === '11',
        'text-info': row.stato_spoglio === '2',
        'text-warning': row.stato_spoglio === '3' || row.stato_spoglio === '13'}">{{row.id_biglietto}}
            </span>

          </td>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="gioco">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.TYPE GAME' | translate}} </th>
          <td mat-cell *matCellDef="let row"> {{betType[row.gioco]}} </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="des_stato">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.STATUS' | translate}}</th>
          <td mat-cell *matCellDef="let row"> {{('TICKETS.' + row.des_stato | uppercase)  | translate}} </td>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="puntata">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.AMOUNT' | translate}} </th>
          <td mat-cell *matCellDef="let row">
            <span
              *ngIf="row.bonus === '0' || row.bonus === '5'">{{row.puntata/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}
            </span>
            <span *ngIf="row.bonus === '1' || row.bonus === '2'" matBadge="{{'CART.B' | translate}}"
              matTooltip="{{'CART.BONUS' | translate}}"
              matBadgeOverlap="false">{{row.puntata/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}
            </span>
            <span *ngIf="row.bonus === '3' || row.bonus === '4'" matBadge="{{'CART.FB' | translate}}"
              matTooltip="{{'CART.FREEBET' | translate}}"
              matBadgeOverlap="false">{{row.puntata/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}
            </span></td>

        </ng-container>

        <ng-container matColumnDef="pagamento_reale">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.WINNING' | translate}} </th>


          <td mat-cell *matCellDef="let row" [ngSwitch]="row.stato_spoglio">
            <span *ngSwitchCase="'0'"
              class="ticket-bg-danger p-2">{{ 0 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <span *ngSwitchCase="'110'"
              class="ticket-bg-danger p-2">{{ 0 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <span *ngSwitchCase="'1'"
              class="ticket-bg-success p-2">
              <span *ngIf="row.pagamento_spoglio > 0 else realeP">{{row.pagamento_spoglio/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
              <ng-template #realeP>{{row.pagamento_reale/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</ng-template>
            </span>
            <span *ngSwitchCase="'11'"
              class="ticket-bg-success p-2">
              <span *ngIf="row.pagamento_spoglio > 0 else realePP">{{row.pagamento_spoglio/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
              <ng-template #realePP>{{row.pagamento_reale/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</ng-template>
            </span>
            <span *ngSwitchDefault>-</span>
          </td>



        </ng-container>

        <ng-container matColumnDef="pagamento_massimo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'CART.MAX WIN' | translate}} </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.pagamento_massimo > 0 else pmassimo">{{row.pagamento_massimo/100 | currency:row.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <ng-template #pmassimo>-</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="stato_spoglio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TICKETS.STATUS' | translate}} </th>
          <td mat-cell *matCellDef="let row"> {{row.stato_spoglio}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="showDetail(row.id_biglietto, row.stato_spoglio, $event, session)"
          *matRowDef="let row; columns: displayedColumns;">
        </tr>
      </table>

      <div class="tickets-bottom">
        <div class="legend-info" *ngIf="!environment.parimCID.includes((identify$ | async)?.token)">
          <span matBadge="{{'CART.B' | translate}}" class="pr-2">{{'CART.BONUS' | translate}}</span>
          <span *ngIf="(identify$ | async)?.stato_tot === '1'" matBadge="T" class="ml-4 pr-2 tot-circle">{{'GENERAL.TOTE' | translate}}</span>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
